module.exports = __webpack_public_path__ + "static/media/check-with-yellow-circle.077a387b.svg";